import React from "react";
import ProjectsContext from "./ProjectsContext";
import styled from "styled-components";
import { Chip } from "@material-ui/core";

const SubContainer = styled.div`
  display: grid;
  // height:72px;
  width: 100%;
  background: #ffffff;
  grid-template-columns: 1fr 200px;
  align-items: left;
`;

const Container = styled.div`
  width: 100%;

  margin-top: 3px;
`;

const StepsContainer = styled.div``;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TypographyContainer = styled.div`
  text-align: center;
`;

const ProxyContainer = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
`;

const SelectedFunctionsSection = styled.div`
  margin-top: 16px;
`;

const SelectedFunctionsTitle = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const SelectedFunctionsList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const SelectedFunctionChip = styled(Chip)`
  margin: 0 8px 8px 0;
`;

class ProjectFunctionsWorkflowHeader extends React.Component {
  static contextType = ProjectsContext;

  renderSelectedFunctions() {
    const { pendingFunctionSelections } = this.context;
    const { selectedProjectOrGbu, selectedFunction } = this.context.reduxStore;

    const assignedFunctionsFromPending = pendingFunctionSelections?.filter(
      (projectFunction) => projectFunction.isChecked
    );

    const assignedFunctionsFromStore = selectedProjectOrGbu?.initialFunctionFormValues?.filter(
      (projectFunction) => projectFunction.isChecked
    );

    const assignedFunctions =
      (assignedFunctionsFromPending && assignedFunctionsFromPending.length && assignedFunctionsFromPending) ||
      (assignedFunctionsFromStore && assignedFunctionsFromStore.length && assignedFunctionsFromStore) ||
      selectedProjectOrGbu?.functions || [];

    const functionsMissingPrimary = this.context.functionsMissingPrimary || {};
    const displayFunctions = assignedFunctions.filter(
      (assignedFunction) => !functionsMissingPrimary[assignedFunction.id]
    );

    if (!displayFunctions.length) {
      return null;
    }

    const selectedFunctionId = selectedFunction?.id;
    const handleChipClick = (assignedFunction) => {
      if (assignedFunction.id === selectedFunctionId) {
        this.context.displayWorkflowDialog();
      } else {
        this.context.selectFunction(assignedFunction);
      }
    };

    return (
      <SelectedFunctionsSection>
      {/*  <SelectedFunctionsTitle>Selected Functions</SelectedFunctionsTitle>
        <SelectedFunctionsList>
          {displayFunctions.map((assignedFunction) => (
            <SelectedFunctionChip
              key={assignedFunction.id}
              label={assignedFunction.name}
              size="small"
              color={
                assignedFunction.id === selectedFunctionId ? "primary" : "default"
              }
              variant={
                assignedFunction.id === selectedFunctionId ? "default" : "outlined"
              }
              onClick={() => handleChipClick(assignedFunction)}
            />
          ))}
        </SelectedFunctionsList>*/}
      </SelectedFunctionsSection>
    );
  }

  render() {
    const reduxStore = (this.context && this.context.reduxStore) || {};
    if (!reduxStore.selectedFunction || !reduxStore.selectedProjectOrGbu) return null;
    

    return (
      <Container>
        
        {this.renderSelectedFunctions()}

      </Container>
    );
  }
}

export default ProjectFunctionsWorkflowHeader;
